import React, { useState, useEffect } from "react";
import {
  MenuItem,
  Select,
  TextField,
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TableView from "../../../CustomComponent/TableView";
import PageHeader from "../../PageHeader";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";
import bulkMarks from "../../../../MarksInBulk.csv";
import { ReactComponent as SubjectIcon } from "../../../images/subjectimage/subjecticon.svg";
import "react-toastify/dist/ReactToastify.css";
import MatrixModel from "./MatrixModel";
import { ToastContainer, toast } from "react-toastify";



function AddMarks({ changeTab }) {
  const classes = useStyles();
  const isMounted = React.useRef(true);
  const previousPageRef = React.useRef(0);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  const { state } = useLocation();
  const total_score = state;
  const [pageSize, setPageSize] = useState(25);
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [marksCache, setMarksCache] = useState({});

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleMatrixQuestionsChange = (newQuestions) => {
    setQuestions(newQuestions);
    const editedQ = newQuestions.find((q) => q.id === matrixState.rowId);
    if (editedQ) {
      setMarksCache((prevCache) => ({
        ...prevCache,
        [editedQ.id]: {
          ...prevCache[editedQ.id],
          correct_answers: editedQ.correct_answers,
        },
      }));
    }
  };

  const style = [
    {
      height: "h65vh",
      style: "viewtable",
      footer: false,
      setPageSize: setPageSize,
      pageSize: pageSize,
      handlePageChange: handlePageChange,
      page: page,
      rowCount: rowCount,
      paginationMode: "server",
    },
  ];
  const { rowId } = useParams();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = bulkMarks;
    link.setAttribute("download", "marksInBulk.csv");

    // Append to the document and trigger the download
    document.body.appendChild(link);
    link.click();

    // Check if the download started (link exists in document)
    if (document.body.contains(link)) {
      toast.success("Sample file for adding marks in bulk has been downloaded");
    } else {
      toast.error("Failed to download the bulk marks file. Please try again.");
    }

    // Clean up
    link.parentNode.removeChild(link);
  };

  const Heading = [
    {
      id: 1,
      pageicon: <SubjectIcon />,
      mainheading: "Add Marks",
      downloadlink: "Download bulk Sample Files",
      onDownload: handleDownload,
      subhead: "Want to Add in Bulk ?",
      showDownloadButton: true,
    },
  ];

  const HeadingSearch = [
    {
      id: 1,
      import: "yes",
      // importApiUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/mark/import`,
       importApiUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/mark/import/${rowId}`,
      export: "yes",
      exportFileName: "Marks.csv",
      exportApiUrl: `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/mark/export/${rowId}`,
      fetchData: () => {
        setMarksCache({});
        fetchAllQuestionsForCache();
        fetchData();
      },
    },
  ];

  const handleSearch = (query) => {
    // TableViewSearch expects an onSearch prop
  };

  const [questions, setQuestions] = useState([]);
  const [examName, setExamName] = useState("");
  const [matrixState, setMatrixState] = useState({
    open: false,
    rowId: null,
    list: [],
    type: "",
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;

  const fetchAllQuestionsForCache = async () => {
    if (!rowId || !decryptedToken) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/mark/by_exam/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      if (isMounted.current) {
        const cache = {};
        response.data.questions.forEach((q) => {
          cache[q.id] = {
            id: q.id,
            exam_id: q.exam_id,
            mark: q.mark || "",
            partial_mark: q.partial_mark || "",
            negative_marking: q.negative_marking || "",
            negative_mark: q.negative_mark || "",
            correct_answers: q.correct_answers || "",
            q_prifix: q.q_prifix,
            question_type: q.question_type,
          };
        });
        setMarksCache((prev) => ({ ...cache, ...prev }));
      }
    } catch (error) {
      if (isMounted.current) {
        console.error("Error fetching all questions for cache: ", error);
      }
    }
  };

  const fetchData = async () => {
    if (!rowId || !decryptedToken) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/mark/by_exam/${rowId}?page=${page + 1}&limit=${pageSize}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      if (isMounted.current) {
        setQuestions(response.data.questions);
        setRowCount(response?.data?.count || response?.data?.questions?.length || 0);
        previousPageRef.current = page;
        console.log("questions12345", response.data.questions);
      }
    } catch (error) {
      if (isMounted.current) {
        toast.error("Failed to fetch questions. Reverting page...");
        setPage(previousPageRef.current);
        console.error("Error fetching data: ", error);
      }
    }
  };

  useEffect(() => {
    if (rowId && decryptedToken) {
      setMarksCache({});
      fetchAllQuestionsForCache();
    }
  }, [rowId]);

  useEffect(() => {
    fetchData();
  }, [rowId, page, pageSize]);

  const handleFieldChange = (id, field, value) => {
    setQuestions((prevQuestions) =>
      prevQuestions.map((question) =>
        question.id === id ? { ...question, [field]: value } : question
      )
    );
    setMarksCache((prevCache) => ({
      ...prevCache,
      [id]: {
        ...prevCache[id],
        [field]: value,
      },
    }));
  };

  const validateQuestions = (cache) => {
    const questionsList = Object.values(cache);
    for (let i = 0; i < questionsList.length; i++) {
      const q = questionsList[i];

      // ❌ Correct Answer empty
      if (
        q.correct_answers === undefined ||
        q.correct_answers === null ||
        String(q.correct_answers).trim() === ""
      ) {
        toast.error(`Correct Answer is required for Question ${q.q_prifix}`);
        return false;
      }

      // ❌ Negative marking YES but negative mark empty
      if (
        q.negative_marking === "yes" &&
        (q.negative_mark === undefined ||
          q.negative_mark === null ||
          String(q.negative_mark).trim() === "")
      ) {
        toast.error(
          `Negative Mark is required for Question ${q.q_prifix}`
        );
        return false;
      }
    }

    return true;
  };


  const handleSave = async () => {
    if (!validateQuestions(marksCache)) {
      return;
    }
    const newQuestion = Object.entries(marksCache).map(([id, question]) => {
      return {
        id: id,
        exam_id: question.exam_id,
        mark: question.mark,
        partial_mark:
          question.partial_mark === "" || question.partial_mark === undefined
            ? null
            : question.partial_mark,
        // partial_mark: question.partial_mark,
        negative_marking: question.negative_marking,
        negative_mark:
          question.negative_mark < 0
            ? question.negative_mark
            : -Math.abs(question.negative_mark),

        question_type: question.question_type,
        correct_answers:
          question?.question_type === "multiple choice"
            ? (typeof question?.correct_answers === "string" ? question?.correct_answers.split(",") : question?.correct_answers)
            : question?.correct_answers,
        question_number: question?.q_prifix,
      };
    });

    const totalMarks = newQuestion.reduce(
      (acc, curr) => acc + Number(curr.mark || 0),
      0
    );

    if (totalMarks !== Number(total_score)) {
      toast.error(
        `Total marks (${totalMarks}) must be equal to Total Score (${total_score})`
      );
      return;
    }

    const data = {
      questions: [...newQuestion],
    };
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/question/mark/update`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      toast.success("Marks updated successfully!");

      // toast.success("Marks updated successfully!");
      fetchData(); // Refresh the data

      setTimeout(() => {
        navigate("/admin/exam");
      }, 2000); // 1.5 sec enoug
    } catch (error) {
      console.error("Error updating marks: ", error);
      toast.error(error.response.data.message);
    }
  };

  const columns = [
    {
      field: "question_no",
      headerName: "Question No",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 120,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    {
      field: "subject",
      headerName: "Subject",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 120,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    {
      field: "question_type",
      headerName: "Question Type",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "marks",
      headerName: "Marks",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <TextField
              onChange={(e) =>
                handleFieldChange(cellValues.row.id, "mark", e.target.value)
              }
              value={cellValues.row.mark || ""}
              type="number"
              variant="outlined"
              required
              placeholder="Enter Marks"
              onWheel={(e) => e.target.blur()}
            />
          </div>
        );
      },
    },
    {
      field: "partial_marks",
      headerName: "Partial Marks",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <TextField
              onChange={(e) =>
                handleFieldChange(
                  cellValues.row.id,
                  "partial_mark",
                  e.target.value
                )
              }
              value={cellValues.row.partial_mark || null}
              type="number"
              variant="outlined"
              required
              placeholder="Enter Partial Marks"
              disabled={cellValues.row.question_type !== "Multiple Choice"}
              onWheel={(e) => e.target.blur()}
            />
          </div>
        );
      },
    },
    {
      field: "negative_marking",
      headerName: "Negative Marking",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <Select
              labelId="negative-marking-label"
              style={{ width: "100px" }}
              id="negative_marking"
              value={cellValues.row.negative_marking || ""}
              onChange={(e) =>
                handleFieldChange(
                  cellValues.row.id,
                  "negative_marking",
                  e.target.value
                )
              }
              displayEmpty
              className={classes.selectEmpty}
              variant="outlined"
            >
              <MenuItem disabled value="">
                Select Option
              </MenuItem>
              <MenuItem value="yes">Yes</MenuItem>
              <MenuItem value="no">No</MenuItem>
            </Select>
          </div>
        );
      },
    },
    {
      field: "negative_mark",
      headerName: "Negative Mark",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            <TextField
              onChange={(e) => {
                let value = e.target.value;

                // Allow only digits (no dots, no negative signs)
                value = value.replace(/[^0-9.]/g, "");
                handleFieldChange(cellValues.row.id, "negative_mark", value);
              }}
              value={
                cellValues.row.negative_mark
                  ? `-${String(cellValues.row.negative_mark).replace(
                    /^[-]+/,
                    ""
                  )}`
                  : ""
              }
              type="text"
              variant="outlined"
              required
              placeholder="Enter Negative Mark"
              disabled={cellValues.row.negative_marking !== "yes"}
              onWheel={(e) => e.target.blur()}
            />
          </div>
        );
      },
    },

    {
      field: "correct_answer",
      headerName: "Correct Answer", // Yeh hai aapka naya field
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 250,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      valueGetter: (params) => {
        // DataGrid version ke hisaab se row data 'row' ya 'data' me ho sakta hai
        const rowData = params.row || params.data;
        return rowData?.correct_answer || "";
      },
      renderCell: (cellValues) => {
        const qType = cellValues.row.question_type
          ? cellValues.row.question_type.toLowerCase()
          : "";
        const value = questions.filter((q) => q.id === cellValues.row.id);

        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
            {qType.includes("match") ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px", // space between inputs
                  flexWrap: "wrap", // optional: wrap if too many
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={(e) => {
                    e.stopPropagation(); // 🔥
                    setMatrixState({
                      open: true,
                      rowId: cellValues.row.id,
                      type: qType,
                    });
                  }}
                >
                  Open {qType}
                </Button>
                <MatrixModel
                  open={matrixState.open}
                  matrixState={matrixState}
                  onClose={() =>
                    setMatrixState({
                      open: false,
                      rowId: null,
                      type: "",
                    })
                  }
                  type={matrixState.type}
                  setQuestions={handleMatrixQuestionsChange}
                  questions={questions}
                />
              </div>
            ) : (
              <TextField
                value={cellValues.row.correct_answers || ""}
                variant="outlined"
                placeholder="Answer"
                disabled={cellValues.row.question_type === 'Essay Writing'}
                onChange={(e) => {
                  let val = e.target.value;
                  if (qType.includes("single")) {
                    if (val.length > 1) {
                      val = val.slice(0, 1).toUpperCase();
                    } else {
                      val = val.toUpperCase();
                    }
                  } else if (
                    qType.includes("multiple") ||
                    qType.includes("choice")
                  ) {
                    val = val
                      .split(",")
                      .map((item) => item.trim().split("")) // Split each item into characters
                      .flat() // Flatten the array
                      .join(",")
                      .toUpperCase();
                  } else if (
                    qType.includes("fill") ||
                    qType.includes("blank")
                  ) {
                    val = val.replace(/[^0-9]/g, "");
                  }
                  handleFieldChange(cellValues.row.id, "correct_answers", val);
                }}
              />
            )}
          </div>
        );
      },
    },
  ];

  const rows = questions.map((d, index) => {
    const cached = marksCache[d.id] || {};
    return {
      id: d.id || "N/A",
      exam_id: d.exam_id || "N/A",
      question_no: d.q_prifix || "N/A",
      question_type: d.question_type || "N/A",
      mark: cached.mark !== undefined ? cached.mark : (d.mark || ""),
      correct_answer: d.correct_answer,
      subject: d?.subject?.subject_name || "N/A",
      partial_mark: cached.partial_mark !== undefined ? cached.partial_mark : (d.partial_mark || ""),
      negative_marking: cached.negative_marking !== undefined ? cached.negative_marking : (d.negative_marking || ""),
      negative_mark: cached.negative_mark !== undefined ? cached.negative_mark : (d.negative_mark || ""),
      correct_answers: cached.correct_answers !== undefined ? cached.correct_answers : (d.correct_answers || ""),
      active_status: d.active_status ? d.active_status : "N/A",
    };
  });

  return (
    <>
      <ToastContainer />
      <div
        className={`${classes.mt1} ${classes.bgwhite} ${classes.inputpadding} ${classes.inputborder}`}
      >
        <PageHeader Heading={Heading} />

        <TableViewSearch Heading={HeadingSearch} onSearch={handleSearch} />

        <TableView columns={columns} rows={rows} Heading={style} />

        <Box
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "10px",
            gap: "10px",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => navigate("/admin/exam")}
            className={classes.mr2}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            onClick={handleSave}
            className={`${classes.custombtnblue}`}
          >
            {"Save Changes"}
          </Button>
        </Box>
      </div>
    </>
  );
}

export default AddMarks;


